module.exports = __webpack_public_path__ + "img/sctper.0b1e7c6f.png";